import React, { Component } from "react"
import PropTypes from 'prop-types'
import MetaTags from 'react-meta-tags';
import { Link } from "react-router-dom"
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardText,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  FormGroup,
  Label,
  Input,
  Button,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap"
import { connect } from "react-redux"

import Breadcrumbs from "../../components/Common/Breadcrumb"
import { getCampaign } from "../../store/campaign/actions"
//i18n
import { withTranslation } from "react-i18next"
import { isEmpty, map, size } from "lodash";
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { DateRangePicker } from 'react-date-range';
import Flatpickr from "react-flatpickr"
import NewsletterChart from "./charts/newsletter-chart";
import CampaignSidebar from "components/VerticalLayout/CampaignSidebar";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Moment from "react-moment";
import BreadcrumbsMass from "components/Common/BreadcrumbMass";
import et1 from "../../assets/img/n-em-1.png"
import et2 from "../../assets/img/n-em-2.png"
import createNew from "../../assets/img/new-email.png"
import axios from "axios";
import { API_URL } from "helpers/app_url";
import ActionEdit from "components/buttons/actionEdit";
import ActionDelete from "components/buttons/actionDelete";
import ActionResend from "components/buttons/actionResend";
import ActionAnalytics from "components/buttons/actionAnalytics";
import Swal from 'sweetalert2';
class NewsletterCamp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      masterTemplates:[],
      customTemplates:[],
      emailTypeDetail:''
    }
     this.toggleReportCanvas = this.toggleReportCanvas.bind(this);
  }
  componentDidUpdate(prevProps) {
    const prevId = prevProps.match.params.campType;
    const currentId = this.props.match.params.campType;

    if (prevId !== currentId) {
        this.fetchMasterTemplate();
        this.fetchCustomeTemplate();
        this.fetchEmailTypeDetail();
        this.fetchAllCamp();
    }
  }
  reporttoggle() {
    this.setState(prevState => ({
      isReportRight: !prevState.isReportRight
    }));
  }
  toggleReportCanvas() {
    this.setState({ report: "", isReportRight: !this.state.isReportRight });
    this.reporttoggle();
  }
   toggleReportCanvas = arg => {
    const report = arg;
    this.setState({
      report: {
        id:report.id,
      
      },
     
    });
    this.fetchReport(report.id);
    this.reporttoggle();
  };
  fetchReport(id) {
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
  
      const params = {
        Id: id,
      };
      axios
        .get(`${API_URL}AgentEmailCampaign/AgentEmailCampaignstats`, { headers, params })
        .then((response) => {
          this.setState({ reportsData: response.data, loading: false });
        })
        .catch((error) => {
          this.setState({ error: error.message, loading: false });
        });
    }
  fetchAllCamp(){
     const { campType } = this.props.match.params;
          const obj = JSON.parse(localStorage.getItem("authUser"));
          const token = obj.resultData.bearerToken;
          const str = 'Bearer ' + token;
          axios.get(API_URL + 'AgentEmailCampaign/allAgentEmailCampaignsByType', {
            params: {
              agentId: localStorage.getItem('userId'),
              typeId: campType
            },
            headers: { Authorization: str }
          })
            .then(res => {
              const campaigns = res.data;
              this.setState({ campaigns });
            })
            .catch(error => {
             
              console.error('Error fetching data:', error);
            })
          
  }

  fetchMasterTemplate() {
    const { campType } = this.props.match.params;
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
      const params = {
          typeId: campType
      }
      axios
        .get(`${API_URL}ProjectMasterEmailTemplate/alltemplatesbytype`, { headers, params })
        .then((response) => {
          this.setState({ masterTemplates: response.data, loading: false });
        })
        .catch((error) => {
          this.setState({ error: error.message, loading: false });
        });
    }

     fetchCustomeTemplate() {
    const { campType } = this.props.match.params;
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
      const params = {
          typeId: campType,
          agentId: localStorage.getItem('userId')
      }
      axios
        .get(`${API_URL}ProjectEmailTemplate/alltemplatesbytype`, { headers, params })
        .then((response) => {
          this.setState({ customTemplates: response.data, loading: false });
        })
        .catch((error) => {
          this.setState({ error: error.message, loading: false });
        });
    }

    fetchEmailTypeDetail() {
      const { campType } = this.props.match.params;
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
   
      axios
        .get(`${API_URL}EmailCampaignType/${campType}`, { headers })
        .then((response) => {
          this.setState({ emailTypeDetail: response.data, loading: false });
        })
        .catch((error) => {
          this.setState({ error: error.message, loading: false });
        });
    }
  componentDidMount() {
    
    const { match: { params }, onGetCampaign } = this.props;
    onGetCampaign(localStorage.getItem('userId'));
    this.fetchMasterTemplate();
    this.fetchCustomeTemplate();
    this.fetchEmailTypeDetail();
    this.fetchAllCamp();

  }
 

   deleteList = (rowData) => {
     Swal.fire({
       title: 'Are you sure?',
       text: 'This action will delete the campaign. You won’t be able to revert this!',
       icon: 'warning',
       showCancelButton: true,
       confirmButtonColor: '#d33',
       cancelButtonColor: '#3085d6',
       confirmButtonText: 'Yes, delete it!'
     }).then((result) => {
       if (result.isConfirmed) {
         const id = rowData.id;
         const obj = JSON.parse(localStorage.getItem("authUser"));
         const token = obj?.resultData?.bearerToken;
   
         fetch(`${API_URL}AgentEmailCampaign/DeleteDraftAgentEmailCampaign?id=${id}`, {
           method: 'DELETE',
           headers: {
             'Content-Type': 'application/json',
             'Authorization': `Bearer ${token}`
           },
         })
           .then((response) => {
             if (!response.ok) throw new Error('Failed to delete campaign');
             return response.json();
           })
           .then((data) => {
             if (data.success) {
                const campaigns = this.state.campaigns.filter(c => c.id !== id);
               this.setState({ campaigns });
               Swal.fire('Deleted!', 'The campaign has been deleted.', 'success');
              
             } else {
               Swal.fire('Failed!', data.message || 'Delete failed.', 'error');
             }
           })
           .catch((error) => {
             console.error('Delete error:', error);
             Swal.fire('Error!', 'Something went wrong.', 'error');
           });
       }
     });
   };
  
    handleResend = (rowData) => {
       const id = rowData.id;
       const obj = JSON.parse(localStorage.getItem("authUser"));
       const token = obj.resultData.bearerToken;
   
       fetch(`${API_URL}AgentEmailCampaign/resendAgentEmailCampaign?Id=${id}`, {
         method: 'GET',
         headers: {
           'Content-Type': 'application/json',
           'Authorization': `Bearer ${token}`,
         },
       })
         .then((response) => {
           if (!response.ok) {
             throw new Error('Failed to resend email campaign');
           }
           return response.json();
         })
         .then((data) => {
           if (data.success === true) {
            
             this.props.history.push(`/campaign/mail-send/${data.agentEmailCampaign.id}/${data.agentEmailCampaign.agentEmailCampaignId	}`);
           } else {
           }
         })
         .catch((error) => {
           console.error('Resend error:', error);
         });
     };



     
  render() {
 
    const { masterTemplates, customTemplates, emailTypeDetail } = this.state;
    

   
    return (
      <React.Fragment>
        {this.props.loading && this.props.loading ? (
                    <div className="loading">Loading&#8230;</div>
                ) : null}
        <div className="page-content project-page-content">
          <MetaTags>
            <title>Create Template | Realty Space</title>
          </MetaTags>
          <Container fluid className="ps-0">
            {/* Render Breadcrumb */}
            <Row>
              <Col sm='2' className="pe-0">
              <CampaignSidebar  />
              </Col>
              <Col sm='10' className="ps-0 pe-0">
              <Row className="project-header">
                <Col sm='7'>
            {/* <Row>
              <Col sm="6"> */}
                <BreadcrumbsMass
                  title={this.props.t("Campaign")}
                  breadcrumbItem={this.props.t("Mass Campaigns")}
                />
              </Col>
              <Col sm="4" className="">
                  <h2>{emailTypeDetail?.emailCampaignTypeTitle}</h2>
              </Col>
            </Row>
          
        
            <Row>
              <Col sm="12">
                
                <Card>
                  <CardBody>
                
          <div className="clearfix"></div>
                   
                         <DataTable className="" stripedRows value={this.state.campaigns} paginator rows={5} rowsPerPageOptions={[10, 20, 30, 50, 100, 150, 200, 500]} currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries " paginatorTemplate=" FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown   " tableStyle={{ minWidth: '50rem' }}   >
                                     <Column
                                      header="#"
                                      body={(rowData, options) => options.rowIndex + 1}
                                      style={{ width: '60px'}}
                                    />
                                    <Column field="date" header="Date" body={(rowData) => (
                                      <Moment format="D MMM YY">{rowData.createdDate}</Moment>
                                    )}></Column>
                                    <Column field="title" header="Title" body={(rowData) => (
                                      rowData.emailCampaignTitle || 'N/A'
                                    )}></Column>
                                    
                                    <Column field="target" header="Target" body={(rowData) => (
          
                                      rowData.emailCampaignTargetTypeTitle ? rowData.emailCampaignTargetTypeTitle + "-" + rowData.emailCampaignTargetTypeSubTitle : 'N/A'
                                    )}></Column>
                                    <Column field="template" header="Theme" body={(rowData) => (
                                      rowData.emailCampaignTemplateTitle || 'N/A'
                                    )}></Column>
                                  
                                    <Column field="status" header="Status" body={(rowData) => (
                                      rowData.emailCampaignPublishStatus
                                    )}></Column>
                                    <Column
                                      field="action"
                                      header="Action"
                                      body={(rowData) => {
                                        const status = rowData.emailCampaignPublishStatus;
          
                                        if (status === 'Draft') {
                                          return (
                                            <>
                                              <ActionEdit to={`/campaign-mails/${rowData.agentEmailCampaignId}/${rowData.id}`} />
                                              <ActionDelete onClick={()=>this.deleteList(rowData)} />
          
                                            </>
                                          );
                                        } else if (status === 'Published') {
                                          return (
                                            <>
                                              <ActionResend onClick={() => this.handleResend(rowData)} />
          
                                              <ActionAnalytics onClick={()=>this.toggleReportCanvas(rowData)} />
                                            </>
                                          );
                                        } else {
                                          return null;
                                        }
                                      }}
                                    />
                                  </DataTable>

              
                    
                  </CardBody>
                </Card>


              </Col>

            
            </Row>
            <Row>
                 <Col lg="6">
              
                                          <Card>
                                            <CardBody>
              
              
                                              <h4 className="card-title mb-4">Available</h4>
              
              
              
                                              <Row className="mb20">
                                                   {map(masterTemplates, (mastertemplate, closekey) => (
                                                 <Col sm="4" className="mb20" key={closekey}> 
                                                      <div className="template-btn">
                                                        <Link
                                                              
                                                              to={`/campaign-mail/${mastertemplate.projectMasterEmailTemplateId	}`}
              
                                                              className="custom-btn"
                                                            >
                                                              {mastertemplate.templateTitle	}
                                                            </Link>
                                                          </div>
                                                      </Col>
                                                   ))}
                                                     
                                              </Row>
                                            </CardBody>
                                          </Card>
                                        </Col>
                                        <Col lg="6">
              
                                          <Card>
                                            <CardBody>
              
              
                                              <h4 className="card-title mb-4">Custom</h4>
                                              <Row className="mb20">
                                                <Col sm="4" className="mb20">
                                                  <Card>
                                                    <CardBody className="p-0">
                                                      <Link
                                                        to={`/editor-email/${this.props.match.params.campType}`}
                                                        className="previewClass card-link float-end tempLink"
                                                      > <img
                                                          src={createNew}
                                                          className="img-fluid"
              
                                                        /></Link>
                                                    </CardBody>
              
                                                  </Card>
                                                </Col>
                                                {map(customTemplates, (customTemplate, closekey) => (
                                                 <Col sm="4" className="mb20" key={closekey}> 
                                                        <Card>
                                                          <CardBody className="p-0">
                                                            <div className="template-btn">
                                                            <Link
                                                              
                                                              to={`/camp-email-editor/${customTemplate.id	}/${this.props.match.params.campType}`}
              
                                                              className="custom-btn"
                                                            >
                                                              {customTemplate.templateTitle	}
                                                            </Link>
                                                            </div>
                                                          </CardBody>
              
                                                        </Card>
                                                      </Col>
                                                   ))}
                                              </Row>
                                            </CardBody>
                                          </Card>
                                        </Col>
            </Row>
            </Col>
            </Row>
          </Container>


        </div>
      </React.Fragment>
    )
  }



}


NewsletterCamp.propTypes = {
  t:  PropTypes.any,
  match:PropTypes.object,
  history:PropTypes.object,
  campaigns:PropTypes.array,
  onGetCampaign:PropTypes.func,
  loading: PropTypes.object

}
const mapStateToProps = ({ campaign }) => (
  {

    campaigns: campaign.campaigns,
    loading: campaign.loading

  })
const mapDispatchToProps = dispatch => ({
  onGetCampaign: (agentId) => dispatch(getCampaign(agentId))
});

export default connect(mapStateToProps,mapDispatchToProps)(withTranslation()(NewsletterCamp))